import { render } from "./OrderTableCashier.vue?vue&type=template&id=3c2b8570"
import script from "./OrderTableCashier.vue?vue&type=script&lang=js"
export * from "./OrderTableCashier.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__